export default __webpack_public_path__ + "static/medias-2d3f627ed73e1b843f1d9e583f9fb282.png";